<div>
  <form (ngSubmit)="onSubmit()" #f="ngForm">
    <div class="form-group">
      <label for="marketName" class="form-label font-weight-bold" style="color: black;" >Market Name</label>
      <input type="text" name="marketname" id="marketname" class="form-control"
      [(ngModel)]="market_location.market_name" required #mname="ngModel" autocomplete="off"
      >
      <span class="text-danger" *ngIf="!mname.valid || mname.untouched">
        <span *ngIf="mname.errors?.required">
          Market Name is required.
        </span>
      </span>
    </div>

    <div class="form-group">
      <label for="locationName" class="form-label font-weight-bold" style="color: black;">Location Name</label>
      <input type="text" name="locationName" id="locationName" class="form-control"
      [(ngModel)]="market_location.location_name" required #lname="ngModel" autocomplete="off">
      <span class="text-danger" *ngIf="!lname.valid || lname.untouched">
        <span *ngIf="lname.errors?.required">
          Location Name is required.
        </span>
      </span>
    </div>

    <div class="form-group">
      <label for="emailAddress" class="form-label font-weight-bold" style="color: black;" >Email Address</label>
      <input type="text" name="emailAddress" id="emailAddress" class="form-control"
      [(ngModel)]="market_location.email_address" required #mailAdd="ngModel" autocomplete="off"
      >
      <span class="text-danger" *ngIf="!mailAdd.valid || mailAdd.untouched">
        <span *ngIf="mailAdd.errors">
          Email is required.
        </span>

      </span>
      
    </div>

    <div class="form-group">
      <label for="remedySupportGroup" class="form-label font-weight-bold" style="color: black;" >Remedy Support Group</label>
      <input type="text" name="remedySupportGroup" id="remedySupportGroup" class="form-control"
      [(ngModel)]="market_location.remedy_support_group" required #remedysg="ngModel" autocomplete="off"
      >
      <span class="text-danger" *ngIf="!remedysg.valid || remedysg.untouched">
        <span *ngIf="remedysg.errors">
          Remedy Support Group is required.
        </span>

      </span>
      
    </div>

    <div class="form-group">
      <label for="remedyTicketSummary" class="form-label font-weight-bold" style="color: black;" >Remedy Ticket Summary</label>
      <input type="text" name="remedyTicketSummary" id="remedyTicketSummary" class="form-control"
      [(ngModel)]="market_location.remedy_ticket_summary" required #remedyts="ngModel" autocomplete="off"
      >
      <span class="text-danger" *ngIf="!remedyts.valid || remedyts.untouched">
        <span *ngIf="remedyts.errors">
          Remedy Support Group is required.
        </span>

      </span>
      
    </div>


    <div class="text-center" id="buttons">
      <button mat-raised-button  color="primary"  type="submit" [disabled]="!f.valid">
        <span *ngIf="editMode">Update Market</span>
        <span *ngIf="!editMode">Insert Market</span>
      </button>
    </div>

  </form>
</div>
